/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { getLineSize, Transaction } from './doc/edit.js';
import { range } from './doc/position.js';
import { type DocFragment, type SelectionSnapshot } from './doc/types.js';
import { stringToDoc } from './doc/utils.js';

export type EditorCommand<A extends unknown[]> = (
  doc: DocFragment,
  selection: SelectionSnapshot,
  ...args: A
) => Transaction | void;

export const Delete: EditorCommand<[]> = (_doc, selection) => {
  return new Transaction().delete(...range(selection));
};

export const InsertText: EditorCommand<[text: string]> = (_doc, selection, text) => {
  const [start, end] = range(selection);
  return new Transaction().delete(start, end).insert(start, stringToDoc(text));
};

export const ReplaceAll: EditorCommand<[text: string]> = (doc, _selection, text) => {
  return new Transaction()
    .delete([0, 0], [doc.length - 1, getLineSize(doc[doc.length - 1]!)])
    .insert([0, 0], stringToDoc(text));
};
